<script setup lang="ts">
import {useStoreBonuses, useStoreIsSpendingBonuses, useStorePrice, useStorePriceLoading} from "~/composables/store/order/mainForm";
import formatPrice from "~/utils/formatPrice";
import {
  useStoreCountMastersInJob,
  useStoreDurationJob
} from "~/composables/store/order/serviceForm";
const storeDuration = useStoreDurationJob()
const hours = ref(Math.floor(storeDuration.value));
const minutes = ref(Math.round((storeDuration.value - hours.value  ) * 60));
const price = useStorePrice()
// пока идёт пересчёт, показанная сумма относится к прошлому набору параметров или обнулена
const priceLoading = useStorePriceLoading()
const bonuses = useStoreBonuses()
const isSpendingBonuses = useStoreIsSpendingBonuses()
const emit = defineEmits(['next'])
const props = defineProps({
  showOrderBtn: Boolean,
  hidePromoCode: Boolean
})
watch(storeDuration, (val) => {
  hours.value =  Math.floor(val);
  minutes.value = Math.round((val - hours.value) * 60);
}, {immediate: true})

const countMasters = useStoreCountMastersInJob()
const goNext = () => {
  emit('next')
}
</script>

<template>
  <div class="order_section w-max max-w-full min-w-[330px] h-fit">
    <p class="h3 mb-6">{{ $t('product.total.title') }}</p>

    <div class="grid grid-cols-2 gap-3 whitespace-nowrap w-max">
      <template v-if="hours || minutes">
        <p class="text-sm font-normal">🕑 {{ $t('order_page.total.duration.title') }}</p>
        <p class="text-base font-bold text-right">~ <span>{{ hours }} {{ $t('order_page.total.duration.hour') }}</span> <span v-if="minutes">{{ minutes }} {{ $t('order_page.total.duration.minutes') }}</span></p>
      </template>

      <template v-if="countMasters">
        <p class="text-sm font-norma">🧑🏻 {{ $t('order_page.total.masters_count') }}</p>
        <p class="text-base font-bold text-right">{{ countMasters }}</p>
      </template>
    </div>

    <div class="w-full h-[1px] bg-secondary-400 my-4"></div>

    <template v-if="!hidePromoCode">
      <ComponentServiceOrderPromoCode/>

      <div class="w-full h-[1px] bg-neutral-light-gray my-6"></div>
    </template>



    <div
        class="bg-yellow-400 p-1 rounded-full text-white font-semibold text-sm flex items-center gap-1 w-fit ml-auto mb-3"
    >
      <IconBonus class="w-4 h-4"/>
      {{formatPrice(bonuses)}}
    </div>

    <div class="flex items-start justify-between">
      <p class="text-base font-normal text-secondary-800">{{ $t('product.total.title') }}</p>

      <div>
        <p v-if="priceLoading" class="skeleton h-7 w-28 rounded-lg"></p>
        <p v-else class="text-2xl font-extrabold">{{ formatPrice(price) }} ₸</p>
      </div>
    </div>

    <div class="flex flex-col gap-3 mt-6">
<!--      <UIBtn-->
<!--          border="green"-->
<!--      >-->
<!--        Поделиться-->
<!--      </UIBtn>-->
      <UIBtn
          v-if="showOrderBtn"
          @click="goNext"
          color="green"
      >
        {{ $t('cart.controls.make_order') }}
      </UIBtn>
    </div>
  </div>
</template>

<style scoped>

</style>